module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAtCAYAAAAOYyOGAAAAq0lEQVRoge3a0Q2AIAwE0GIYif0nYCf8auIHghErvebeAvbSUhMxtdYESSlFq70t/IBK9FC+JO+qtTouvy9mp0azKSLpx1o+k3c8dDby6u3ohx2/nUxGP2SnGAoFF4WyXsmrVrefyxc3zxQKhkLBUCgYCgVDoWAoFAyFgqFQMBQKfnjpcHmBwE4p7xdxXBQoeKYMmGzPLaGsF01GvaweiXmmEH/+mInXKRE5AbfJGDm49c5cAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left1.png
// module id = 2xXe
// module chunks = 1